import { createContext, useContext } from 'react';

/**
 * Whether the part of the tree under it shows the redesigned projects page
 * (the project list and the project dashboard, in the project bank's look).
 *
 * The projects page provides it from the user's own choice
 * (selectIsProjectPageRedesignEnabled). Components the page shares with the
 * rest of Lixani — DashboardButton, SideBadge, ProjectListItem in the timer
 * drawer — read this context rather than the setting, so everywhere else they
 * keep their classic look whatever the user chose; without a provider it is
 * false.
 */
const ProjectPageRedesignContext = createContext(false);

ProjectPageRedesignContext.displayName = 'ProjectPageRedesignContext';

/** Provides the redesign to its subtree: `<ProjectPageRedesignProvider value={bool}>`. */
export const ProjectPageRedesignProvider = ProjectPageRedesignContext.Provider;

/** True inside a projects page that shows the redesign. */
export const useProjectPageRedesign = () =>
  useContext(ProjectPageRedesignContext);

export default ProjectPageRedesignContext;
